export default function cloudPathHandler ({ to }) {
  if (to.params.parent_id) return { ...to, params: { ...to.params, parent_id: 'root' } }
}
